import { cva, type VariantProps } from "class-variance-authority"

export const sectionVariants = cva("", {
  variants: {
    variant: {
      default:
        "text-card-foreground rounded-lg border border-gray-700/50 bg-gray-800/50 shadow-sm text-pretty backdrop-blur-sm p-4",
      unstyled: ""
    }
  },
  defaultVariants: {
    variant: "default"
  }
})

export type SectionVariants = VariantProps<typeof sectionVariants>
